<template>
  <div>
    <v-form>
      <v-row text-align="center" justify="end" no-gutters>
        <!-- フィルターボタン -->
        <v-col cols="auto" style="height: 6vh; display: flex; align-items: center">
            <v-btn
              icon
              :style="{ backgroundColor: isIconInverted ? 'black' : 'white',
                marginRight: '7vh'
               }"
              @click="handleButtonClick"
            >
              <v-tooltip activator="parent" location="bottom">フィルター</v-tooltip>
              <v-icon :color="isIconInverted ? 'white' : 'black'">mdi-filter</v-icon>
            </v-btn>

            <v-dialog v-model="showDialog" max-height=20vh max-width="300">
              <v-card>
                <v-card-title>選択してください</v-card-title>
                <v-card-actions>
                  <v-btn text @click="onChangeClick()">変更</v-btn>
                  <v-btn text @click="onClearClick">クリア</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text @click="showDialog = false">キャンセル</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>

        <!-- 検索アイコンボタン -->
        <v-col cols="auto" style="height: 6vh; display: flex; align-items: center">
          <v-btn icon style="margin-right: 7vh" @click="toggleSearch()">
            <v-tooltip activator="parent" location="bottom">カード名検索</v-tooltip>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>

        <!-- スキルシート一覧ボタン -->
        <v-col v-if="getScreenName === '営業対象者画面'" cols="auto" style="height: 6vh; display: flex; align-items: center">
          <v-btn icon style="margin-right: 7vh" @click="openSkillSheet">
            <v-tooltip activator="parent" location="bottom">全社員スキルシート一覧</v-tooltip>
            <v-icon>mdi-file-multiple</v-icon>
          </v-btn>
        </v-col>

        <!-- ソートボタン -->
        <v-col cols="auto" style="height: 6vh; display: flex; align-items: center">
          <v-btn icon style="margin-right: 7vh" @click="openSortDialog">
            <v-tooltip activator="parent" location="bottom">ソート</v-tooltip>
            <v-icon>mdi-sort</v-icon>
          </v-btn>
        </v-col>

        <!-- プロパティ編集ボタン -->
        <v-col cols="auto" style="height: 6vh; display: flex; align-items: center">
          <v-btn icon style="margin-right: 7vh" @click="openDialog">
            <v-tooltip activator="parent" location="bottom">プロパティ編集</v-tooltip>
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </v-col>

        <!-- 新しいステータスを追加 -->
        <v-col cols="auto" style="height: 6vh; display: flex; align-items: center">
          <v-btn icon style="margin-right: 7vh" @click="openAddStatusDialog">
            <v-tooltip activator="parent" location="bottom">新しいステータスを追加</v-tooltip>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>

        <!-- プロパティチェックボタン -->
        <v-col cols="auto" style="height: 6vh; display: flex; align-items: center">
          <v-btn icon style="margin-right: 7vh" @click="openCheckDialog">
            <v-tooltip activator="parent" location="bottom">プロパティ表示設定</v-tooltip>
            <v-icon>mdi-checkbox-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- ステータス追加ダイアログ -->
      <v-dialog v-model="statusDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">新しいステータスを追加</v-card-title>
          <v-card-text>
            <v-text-field v-model="newStatusTitle" label="ステータス名" outlined required></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="saveNewStatus(newStatusTitle)">保存</v-btn>
            <v-btn text @click="closeStatusDialog">キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- エラーダイアログ -->
      <v-dialog v-model="errorDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">エラー</v-card-title>
          <v-card-text> ステータス名を入力してください。 </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="errorDialog = false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- CardEditコンポーネントを表示 -->
      <v-col cols="12">
        <CardEdit @triggerSearch="getSearchResultFromApi" :data="this.properties" :tableId="this.tableId"
          :searchResult="searchResult" />
      </v-col>
    </v-form>

    <!-- フィルターダイアログ -->
    <FilterDialog v-model="filterDialog" :data="cardData" @update:filterResult="filterResult" />

    <!-- 検索テキストフィールドをポップアップ -->
    <SearchDialog v-model="searchDialog" :data="cardData" @updateSearchQuery="handleSearch" /> 

    <!-- ソートダイアログ -->
    <SortDialog v-model="sortDialog" :data="cardData" @applySelection="handleSortUpdate" />

  <v-dialog v-model="skillSheetDialog" max-width="800px">
    <v-card>
      <v-card-title>スキルシート一覧
        <v-text-field
            v-model="searchStaff"
            label="検索"
            solo
            clearable
            class="search-field"
            append-inner-icon="mdi-magnify"
            @input="filterStaffList"
            :style="{ width: '40%'}"
          />
      </v-card-title>
      <v-card-text>
        <v-table>
          <thead>
            <tr>
              <th>名前（押下すると該当社員のスキルシートに遷移されます）</th>
            </tr>
          </thead>
          <tbody>
               <tr v-for="staff in filteredStaffList" :key="staff.staffId">
                <td><a :href="'http://dev.nurinubi.com:20081/skillsheet?staffId=' + staff.staffId">
                    {{ staff.staffName }}
                  </a></td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="skillSheetDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- プロパティ編集ダイアログ (条件付き表示) -->
    <property-edit v-if="propertyDialog" @update:dialogVisible="updateDialogVisible" :dialogVisible="propertyDialog"
      :data="cardData" :tableId="tableId" @refreshProperties="getBoardViewInfo" @triggerSearch="getSearchResultFromApi" />
    <card-edit @refreshProperties="getBoardViewInfo" />

    <!-- プロパティチェックダイアログ (条件付き表示) -->
    <property-check v-if="propertyCheckDialog" @triggerSearch="getSearchResultFromApi" @update:checkDialogVisible="updateCheckDialogVisible" :checkDialogVisible="propertyCheckDialog"
      :data="cardData" :tableId="tableId" :properties="properties" @refreshProperties="getBoardViewInfo" />
    <card-edit @refreshProperties="getBoardViewInfo" />
    <card-side-bar @refreshBoardView="getBoardViewInfo" />
  </div>
</template>

<script>
import CardEdit from "./CardEdit.vue";
import CardSideBar from "./CardSideBar.vue";
import PropertyEdit from "./PropertyEdit.vue";
import PropertyCheck from "./PropertyCheck.vue";
import SearchDialog from "./SearchDialog.vue";
import FilterDialog from "./FilterDialog.vue";
import SortDialog from "./SortDialog.vue";
import boardViewApi from "@/api/boardView.js";
import searchApi from "@/api/search.js";
import cardSidebarApi from "@/api/cardSidebar";
import taskCardApi from "@/api/card";
import getStaffNameApi from "@/api/getStaffInfo.js";
import eventBus from "@/eventBus";

export default {
  components: {
    CardSideBar,
    CardEdit,
    PropertyEdit,
    PropertyCheck,
    SearchDialog,
    FilterDialog,
    SortDialog,
  },
  data() {
    return {
      errorDialog: false,
      newStatusName: "",
      statusDialog: false, // ダイアログの表示/非表示
      newStatusTitle: "", // 新しいステータス名
      statusList: [], // ステータスリスト
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      cardData: [],
      filterCondition: [],
      searchResult: [],
      searchQuery: "", // 検索語を管理
      sortCondition: {},
      tableId: null,
      searchConditions: [],
      showSaveButton: false, // 保存ボタンを表示するフラグ
      searchCardWord: null,
      screenId: 3,
      boardTitle: "ボードビュー", // ボードタイトル
      sortDialog: false,
      filterDialog: false,
      propertyDialog: false, // ダイアログの表示状態
      propertyCheckDialog: false, 
      skillSheetDialog: false,
      searchDialog: false, // 検索欄の表示/非表示を制御するフラグ
      searchWord: "", // 検索コンポーネントから受けとる検索語
      selectedSort: "",
      staffList: [],
      searchStaff: '',
      filteredStaffList: [],
      properties: [],
      selectOption: [
        { id: 1, value: "未着手" },
        { id: 2, value: "設計" },
        { id: 3, value: "実装" },
        { id: 4, value: "単体テスト" },
        { id: 5, value: "結合テスト" },
        { id: 6, value: "完了" },
      ],
      sendData: {}, // 未定義の変数を定義
      isIconInverted: false,
      showDialog: false,
    };
  },
  computed: {
    getScreenName() {
      const screenData = JSON.parse(sessionStorage.getItem('screenData'));
      console.log("screenData:", screenData);
      return screenData ? screenData.screenName : '';
    },
  },
  watch: {
    searchResult: {
      handler() {
        this.loadTaskCards();
      },
    },
    tableId: {
      handler() {
        this.getBoardViewInfo();
      },
    },
    $route: {
      handler() {
        this.getBoardViewInfo();
      },
      immediate: true,
    },
    statusDialog(val) {
    if (val === false) {
      this.newStatusTitle = null;
    }
  }
  },
  mounted() {
    this.getSearchResultFromApi();
    eventBus.on('filter-updated', () => {
    this.isIconInverted = true;});
    eventBus.on("refreshBoardView", () => {
    this.getSearchResultFromApi();});
  },
  created() {
    this.addSelectOptionsToProperties();
    this.loadTaskCards();
  },
  methods: {
    closeStatusDialog() {
      this.statusDialog = false;
      this.newStatusTitle = null;
    },
    handleButtonClick() {
      if (this.isIconInverted) {
        this.showDialog = true;
      } else {
        this.openFilterDialog();
      }
    },
    onChangeClick() {
      this.showDialog = false
      this.openFilterDialog();
    },
    onClearClick() {
      eventBus.emit("clear");
      this.showDialog = false
      this.isIconInverted = false;
      this.filterResult([]);
      this.filterCondition = [];
      const authInfo = {
          authUserId: this.authUserId,
          sessionKey: this.sessionKey,
        };
      const tableId = sessionStorage.getItem("tableId");
      this.searchResult = searchApi.searchTaskCards(
            authInfo,
            tableId,
            '',
            [],
            {}
          );
    },
    openAddStatusDialog() {
      this.statusDialog = true;
    },
    async saveNewStatus(newStatusTitle) {
      const tableId = sessionStorage.getItem("tableId");

      if (!newStatusTitle) {
        this.errorDialog = true;
        return;
      }
      const invalidCharRegex = /\\\\|[,:]/;
      if (invalidCharRegex.test(newStatusTitle)) {
          alert("ステータス名に「\\\\」「,」「:」は使用できません。");
          return;
        }

      if (newStatusTitle.trim()) {
        const data = await this.searchResult;
        const existingStatusList = data
          .map(item => item.selectionData?.trim())
          .filter(val => val);

        if (existingStatusList.includes(newStatusTitle.trim())) {
          alert("既に存在するステータスです。");
          return;
        }
        const staffName = localStorage.getItem("staffName");
        this.newStatusTitle = newStatusTitle.trim();
        this.statusDialog = false;
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        await cardSidebarApi.addStatus(
          tableId,
          this.newStatusTitle,
          staffName,
          authUserId,
          sessionKey
        );
        await this.getSearchResultFromApi();
        await this.getBoardViewInfo();
        await this.$emit("triggerSearch");
        await this.loadTaskCards();
      } else {
        this.errorDialog = true;
        console.log("saveNewStatus - 失敗: Title is empty");
      }
    },
    async addNewCard(propertyId, statusKey, cardTitle) {
      try {
        const staffName = localStorage.getItem("staffName");
        // console.log(
        //   "カード追加propertyId:",
        //   propertyId,
        //   "statusKey:",
        //   statusKey,
        //   "cardTitle:",
        //   cardTitle
        // );
        await taskCardApi.addNewCard(
          this.authUserId,
          this.sessionKey,
          this.tableId,
          propertyId,
          statusKey,
          cardTitle,
          staffName
        );
        await this.getSearchResultFromApi();
        await this.$emit("triggerSearch");

        this.loadTaskCards();

        console.log("addNewCard - 成功");
      } catch (error) {
        console.error("addNewCard - 失敗:", error.message);
      }
    },
    async loadTaskCards() {
      try {
        this.uniqueStatus = await this.searchResult;
        // console.log(
        //   this.searchResult,
        //   "loadTaskCards Called",
        //   this.uniqueStatus
        // );
      } catch (error) {
        this.errorMessage =
          error.message || "タスクカードの読み込みに失敗しました";
        console.log(error.message);
      }
    },
    async updateCardInfo(updatedTask) {
      // console.log("updateCardInfo:", updatedTask);
      const cardIndex = this.cards.findIndex(
        (card) => card === this.selectedCard
      );
      if (cardIndex !== -1) {
        this.cards[cardIndex] = { ...this.selectedCard, ...updatedTask };
        // console.log("updateCardInfo:", this.cards[cardIndex]);
      } else {
        // console.log("updateCardInfo - Card not found");
      }
      await this.getSearchResultFromApi();
      this.$emit("triggerSearch");
      this.loadTaskCards();
      this.closeSidebar();
    },
    async handleSearch(newSearchQuery) {
      this.searchQuery = newSearchQuery;
      await this.getSearchResultFromApi();
      this.searchQuery = "";
    },
    // 子コンポーネントから配列を受け取る
    filterResult(filterArray) {
      this.filterCondition = filterArray; // 親の`filterList`を更新
      this.getSearchResultFromApi();
    },
    async openSkillSheet() {
      this.skillSheetDialog = true;
      const authUserId = localStorage.getItem("authUserId");
      const sessionKey = localStorage.getItem("sessionKey");

      try {
        const response = await getStaffNameApi.getAllStaffName(authUserId, sessionKey);
        if (response.staffList) {
          this.staffList = response.staffList;
        } else {
          console.error("データがありません。");
        }
      } catch (error) {
        console.error("APIエラー:", error);
      }
      this.filteredStaffList = this.staffList;
    },
    filterStaffList() {
      if (this.searchStaff === '') {
        this.filteredStaffList = this.staffList;
      } else {
        this.filteredStaffList = this.staffList.filter(staff => {
          return staff.staffName.toLowerCase().includes(this.searchStaff.toLowerCase());
        });
      }
    },
    closeSkillSheet() {
      this.skillSheetDialog = false;
      this.selectedStaff = null;
    },
    selectStaff(staff) {
      this.selectedStaff = staff;
    },
    async getSearchResultFromApi() {
      // APIにフィルター条件を渡して呼び出す
      try {
        const authInfo = {
          authUserId: this.authUserId,
          sessionKey: this.sessionKey,
        };
        const tableId = sessionStorage.getItem("tableId");
        const searchWord = this.searchQuery;
        const filterList = this.filterCondition;
        const sort = this.sortCondition;
        if (tableId) {
          this.searchResult = searchApi.searchTaskCards(
            authInfo,
            tableId,
            searchWord,
            filterList,
            sort
          );
        } else {
          console.log("tableIdがNULL又はUndefinedです");
        }
      } catch (error) {
        console.error(
          "フィルターデータの取得中にエラーが発生しました:",
          error.message
        );
      }
      // ここでフィルター結果を処理する
    },

    async getBoardViewInfo() {
      this.loading = true;
      this.tableId = sessionStorage.getItem("tableId");
      if (
        this.tableId != "undefined" &&
        this.tableId != null &&
        this.tableId != undefined
      ) {
        const authInfo = {
          authUserId: this.authUserId,
          sessionKey: this.sessionKey,
        };

        this.cardData = await boardViewApi.getBoardViewInfo(
          this.tableId,
          authInfo,
        );
        if (this.cardData && Array.isArray(this.cardData.data)) {
          // 検索結果を取得できた場合は格納
          this.properties = this.cardData.data[0].properties;
          this.ErrMsg = null;
          this.boardTitle = this.cardData.data[0].tableInfoDto.tableName;
        } else {
          // データが取得できなかった場合の処理
          this.properties = null;
          this.ErrMsg = "データが存在しません";
          console.log("データが存在しません");
        }
      } else {
        console.log("tableIdがNULL又はUndefinedです tableId: ", this.tableId);
      }
      this.loading = false;
    },
    handler() {
      try {
        // const properties = this.getBoardViewInfo();
        // console.log("Unique properties:", properties);
      } catch (error) {
        console.error("エラーが発生しました:", error.message);
      }
    },
    openSortDialog() {
      this.sortDialog = true;
    },
    // 子から受け取ったソートの値を処理するメソッド
    handleSortUpdate(selectedCondition) {
      this.sortCondition = selectedCondition; // 受け取った値を格納
      this.getSearchResultFromApi();
    },
    // フィルターダイアログを開く
    openFilterDialog() {
      this.filterDialog = true;
    },
    updateSearchCondition(searchWord) {
      this.searchQuery = searchWord;
      this.getSearchResultFromApi();
    },
    toggleSearch() {
      this.searchDialog = true; // クリックで検索欄の表示/非表示を切り替え
    },
    // ダイアログを開く
    async openDialog() {
      await this.getBoardViewInfo();
      this.propertyDialog = true;
    },
    // ダイアログの表示状態を更新
    updateDialogVisible(newVal) {
      this.propertyDialog = newVal;
    },
    openCheckDialog() {
      this.propertyCheckDialog = true;
    },
    // ダイアログの表示状態を更新
    updateCheckDialogVisible(newVal) {
      this.propertyCheckDialog = newVal;
    },
    addSelectOptionsToProperties() {
      // `properties` 配列の各プロパティに対して処理
      this.properties.forEach((property) => {
        if (property.type === "セレクト") {
          // `type` が "セレクト" の場合、`selectOption` を `options` として追加
          property.options = this.selectOption.map((option) => option.value);
        }
      });
    },
    onFilterEvent() {
      this.isIconInverted = true;
    },
    // 検索メソッドを追加
    searchMethod() {
      this.$emit("updateSearch", this.searchWord);
      this.closeDialog();
    },
    // 子から検索語を受け取るメソッドを追加
    receiveSearchWord(searchWord) {
      this.searchWord = searchWord;
      this.getSearchResultFromApi(this.filterCondition);
    },
  },
};
</script>

<style scoped>
.editable-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 0 1vh;
  cursor: pointer;
  background-color: #ffffff;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.editable-title:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.editable-title span {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.editable-title v-btn {
  color: #757575;
  transition: color 0.3s ease;
}

.editable-title v-btn:hover {
  color: #000;
}

.board {
  display: flex;
  gap: 16px;
  width: 70%;
}

.board>.column {
  flex: 1;
  min-width: 0;
}

* .class-v-text-field.v-text-field>>>input {
  font-weight: bold;
  border: none !important;
}

.class-v-text-field {
  position: relative;
  padding-right: 40px;
  /* アイコンとボタンのスペース */
}

h1 {
  font-size: 1rem;
  text-align: start;
}

.inverted-icon {
  filter: invert(1);
}

</style>
